import * as annotationActions from '../../actions/annotationActions';
import * as utils from './annotation.utils';

function annotationReducer(state, action) {
  const { payload, prop, stateTree } = action;
  const annotation = state || utils.getInitialState(stateTree);

  switch (action.type) {
    case annotationActions.UPDATE_ANNOTATION:
      return { ...annotation, [prop]: payload };
    default:
      return annotation;
  }
}

export default annotationReducer;
